import { prop } from 'ramda';
import { languageService } from '@theme/js/services/language.service';
import { useAppSelector, useGameConfigurationSelector, useUserSelector } from '@core/js/store/hooks';
import { IGame } from '@core/js/hooks/games/types';
import { useCallback } from 'react';

const getGameInfoOld = (game: IGame, language: string, languages: [string]) => {
    if (game?.additionalAssets?.[0]?.name !== 'game-info') {
        return { isArticleIdPathPresent: false, linkToPage: '' };
    }

    const articleId = game?.articleId;
    const isArticleIdPathPresent = Boolean(articleId?.startsWith('/'));
    if (!isArticleIdPathPresent) {
        return { isArticleIdPathPresent, linkToPage: '' };
    }

    const articleIds = articleId
        .split(',')
        .map((id) => id.trim())
        .filter(Boolean)
        .map((id) => id.startsWith('/') ? id : `/${id}`);

    const pageLinks = languages.reduce(
        (acc: Record<string, string>, lang: string, index: number) => {
            acc[lang] = articleIds[index] || articleIds[0];
            return acc;
        },
        {} as Record<string, string>
    );

    return { isArticleIdPathPresent, linkToPage: pageLinks[language] || '' };
};
const getGameInfo = (game: IGame, language: string) => {
    const gamePageConf = game?.gameCustomFieldsData?.find(item =>
        item?.name === `game-info-page-${language.toUpperCase()}`);

    if (gamePageConf && gamePageConf.value) {
        return { isArticleIdPathPresent: true, linkToPage: gamePageConf.value };
    }
    return { isArticleIdPathPresent: false, linkToPage: '' };
};

export const useGetAssetRedirectData = () => {
    const language = languageService.getTwoLetterLanguage(useUserSelector(prop('lang')));
    const languages = languageService.getAllLocalesTwoLetterLanguage(); // ['en', 'de', 'fr', 'it']
    const games = useGameConfigurationSelector(prop('games'));
    const dynamicTags = useAppSelector(prop('dynamicTags'));
    const openOld = String(dynamicTags?.DTAG_OPEN_GAME_INFO_OLD).toLowerCase() === 'true';

    return useCallback((code: string) => {
        const game = games[code];
        if (openOld) {
            return getGameInfoOld(game, language, languages);
        }
        return getGameInfo(game, language);
    }, [games, language, openOld, languages]);
};

export const useAssetRedirectData = (code: string, gameGridType?: 'responsiveGameGrid' | 'gameGrid') => {
    const language = languageService.getTwoLetterLanguage(useUserSelector(prop('lang')));
    const languages = languageService.getAllLocalesTwoLetterLanguage(); // ['en', 'de', 'fr', 'it']
    const games = useGameConfigurationSelector(prop('games'));
    const dynamicTags = useAppSelector(prop('dynamicTags'));
    const openOld = String(dynamicTags?.DTAG_OPEN_GAME_INFO_OLD).toLowerCase() === 'true';
    const game = games[code];

    if ((gameGridType === 'responsiveGameGrid' || openOld) && gameGridType !== 'gameGrid') {
        return getGameInfoOld(game, language, languages);
    }

    return getGameInfo(game, language);
};
